export default function InputDiv({form}){
    return(
    <div className="main-input-div">
        {form}
    </div>)
}